import { Typography } from '@qbe/ads-core';
import React from 'react';

import { useAppContent, useAppSelector } from '~/hooks';
import { selectAppDetails, selectHasMultipleReferrals } from '~/selectors/selectAppDetails';
import { getReferralContent } from '~/utils/getReferralContent';

const PartnerBanner = (_: { type?: 'quote' }) => {
  const hasMoreThanOneReferral = useAppSelector(selectHasMultipleReferrals);
  const { groups } = useAppSelector(selectAppDetails);

  // determine which referral content to show
  let referralContent: string | undefined;
  if (!hasMoreThanOneReferral) {
    referralContent = getReferralContent(groups);
  }

  const { getJSXContent } = useAppContent({ basePath: `dsme.referralPartnerBanner` });

  // do not render if there is more than one referral type
  return !hasMoreThanOneReferral && referralContent ? (
    <Typography variant="body3" data-track="partnerBannerTCs">
      {getJSXContent(`content.${referralContent}.description`)}
    </Typography>
  ) : null;
};

export default PartnerBanner;
